export {default as NewsSkeleton} from './news-skeleton' 